import { Link } from 'react-router-dom';

const PHONE = '07760 881212';
const EMAIL = 'ryan.hopson@hotmail.co.uk';

export default function Footer() {
  return (
    <footer className="bg-navy-800 text-white font-body">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 flex items-center justify-center bg-gold-400 rounded-md">
              <i className="ri-flashlight-fill text-navy-800 text-xl"></i>
            </div>
            <div className="flex flex-col leading-none">
              <span className="font-heading font-extrabold text-gold-400 text-lg tracking-tight leading-none">DUKERIES</span>
              <span className="font-heading font-bold text-white text-xs tracking-widest leading-none mt-0.5">ELECTRICAL</span>
            </div>
          </div>
          <p className="text-gold-200/70 text-sm leading-relaxed mb-5">
            Dukeries Electrical — your trusted local electrician in Worksop and surrounding areas. Fast, reliable, and honestly priced.
          </p>
          <a
            href={`tel:${PHONE.replace(/\s/g, '')}`}
            className="inline-flex items-center gap-2 bg-gold-400 hover:bg-gold-300 text-navy-800 font-bold text-sm px-5 py-3 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-base"></i>
            </span>
            Call Us Now
          </a>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="font-heading font-bold text-lg uppercase tracking-wide text-gold-400 mb-5">
            Quick Links
          </h3>
          <ul className="space-y-2.5">
            {[
              { label: 'Home', to: '/' },
              { label: 'Services', to: '/services' },
              { label: 'Locations', to: '/locations' },
              { label: 'About Us', to: '/about' },
              { label: 'Blog', to: '/blog' },
            ].map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="flex items-center gap-2 text-gold-200/70 hover:text-gold-400 text-sm transition-colors cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-gold-400"></i>
                  </span>
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="font-heading font-bold text-lg uppercase tracking-wide text-gold-400 mb-5">
            Services
          </h3>
          <ul className="space-y-2.5">
            {[
              'Emergency Electrician',
              'Full Rewiring',
              'Fuse Board Upgrade',
              'EICR Certificate',
              'Domestic Electrician',
            ].map((s) => (
              <li key={s}>
                <Link
                  to="/services"
                  className="flex items-center gap-2 text-gold-200/70 hover:text-gold-400 text-sm transition-colors cursor-pointer"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-flashlight-fill text-gold-400"></i>
                  </span>
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="font-heading font-bold text-lg uppercase tracking-wide text-gold-400 mb-5">
            Get in Touch
          </h3>
          <div className="space-y-3 text-sm text-gold-200/70">
            <div className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-phone-fill text-gold-400"></i>
              </span>
              <div>
                <p className="text-white font-semibold">{PHONE}</p>
                <p>Call or email for a free quote</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-mail-fill text-gold-400"></i>
              </span>
              <div>
                <a href={`mailto:${EMAIL}`} className="text-white font-semibold hover:text-gold-400 transition-colors cursor-pointer">
                  {EMAIL}
                </a>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-map-pin-fill text-gold-400"></i>
              </span>
              <div>
                <p>Worksop, Nottinghamshire</p>
                <p>Covering S80, S81 &amp; surrounding areas</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                <i className="ri-shield-check-fill text-gold-400"></i>
              </span>
              <div>
                <p>Fully Insured &amp; NAPIT Registered</p>
                <p>Part P Registered</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gold-400/20 py-5 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-gold-200/50">
          <p>&copy; 2026 Dukeries Electrical. All rights reserved. Fully Insured &amp; NAPIT Registered.</p>
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-check-fill text-gold-400 text-xs"></i>
              </span>
              Fully Insured
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-award-fill text-gold-400 text-xs"></i>
              </span>
              NAPIT Registered
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-time-fill text-gold-400 text-xs"></i>
              </span>
              Fast Response
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
